/**
 * Даты приходят с бэкенда строками, хотя во view-моделях объявлены как `Date`, поэтому
 * сравнивать их напрямую нельзя: `createdAt.getTime()` на таком значении падает.
 */
export function sortByCreatedAtDesc<T extends { createdAt: Date | string }>(records: T[]): T[] {
    return [...records].sort((first, second) => toMs(second.createdAt) - toMs(first.createdAt));
}

function toMs(value: Date | string): number {
    return new Date(value).getTime();
}
